import gql from 'graphql-tag'

export const userUpdate = gql`
  mutation UpdateUserSetting($id: ID!, $setting: String!) {
    updateUserSetting(input: {id: $id, setting: $setting}) {
      settings {
        setting
        id
        accountId
      }
    }
  }
`
